import * as THREE from 'three';
import getProjectionMatrix from '../../utils/getProjectionMatrix';
import { getCamera, getCameraWorldTransform, getRect } from '../../../modules/player';
import { find, get, getWorldTransform, set } from '../../../modules/scene';

const invCameraWorldMatrix = new THREE.Matrix4();
const cameraProjectMatrix = new THREE.Matrix4();
const cameraUnprojectMatrix = new THREE.Matrix4();

const nodePosition = new THREE.Vector3();
const referencePoint = new THREE.Vector3();
const relativeDelta = new THREE.Vector2();
const deltaReferencePoint = new THREE.Vector3();

export default function getProjectedPoint(store, nodeId, x, y) {
  const cameraId = getCamera(store);
  const cameraWorldMatrix = getCameraWorldTransform(store);
  var projectionMatrix = getProjectionMatrix(get(store, { id: cameraId, evalPlug: 'Camera' }));
  invCameraWorldMatrix.getInverse(cameraWorldMatrix, true);
  cameraProjectMatrix.copy(projectionMatrix).multiply(invCameraWorldMatrix);

  const nodeMatrix = getWorldTransform(store, nodeId);
  if (!nodeMatrix) return;

  const rect = getRect(store);
  const parentMatrix = getWorldTransform(store, find(store, { id: nodeId, parent: true }));
  nodePosition.setFromMatrixPosition(nodeMatrix);
  relativeDelta.set(x, -y).divide(rect).multiplyScalar(2.0);

  referencePoint.copy(nodePosition).applyMatrix4(cameraProjectMatrix);
  referencePoint.x = 0;
  referencePoint.y = 0;
  deltaReferencePoint.set(relativeDelta.x, relativeDelta.y, referencePoint.z);

  cameraUnprojectMatrix.getInverse(cameraProjectMatrix, true);
  referencePoint.applyMatrix4(cameraUnprojectMatrix);
  deltaReferencePoint.applyMatrix4(cameraUnprojectMatrix).sub(referencePoint);

  return deltaReferencePoint;
};



// WEBPACK FOOTER //
// ./src/translators/tools/utils/getProjectedPoint.js